"use client";

import { Zap, FileText, Palette, Megaphone, FileSpreadsheet, Smartphone } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Web Design & Development",
  description: "High-performance, responsive websites designed to work while you sleep and convert visitors into loyal customers.",
  icon: Zap
}, {
  title: "Social Media Management",
  description: "Strategic content and engagement plans that build your brand presence across all major digital platforms.",
  icon: Smartphone
}, {
  title: "Brand Identity & Logo Design",
  description: "Premium visual identities that capture your business essence with bold, clean, and memorable aesthetics.",
  icon: Palette
}, {
  title: "SEO & Content Strategy",
  description: "Advanced optimization and data-driven content to ensure your business ranks where your customers are looking.",
  icon: FileText
}, {
  title: "Landing Page Design",
  description: "High-conversion single pages built with advanced technology to maximize your marketing campaign ROI.",
  icon: Megaphone
}, {
  title: "Website Maintenance",
  description: "Reliable support and technical updates to keep your digital arsenal running smoothly and securely 24/7.",
  icon: FileSpreadsheet
}];
export default function OurDigitalArsenal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263864" id="our-digital-arsenal" className="bg-background text-foreground ![padding:30px_0px_112px_0px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div ref={ref} className={`mb-16 text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl mb-4">
            Our Digital Arsenal
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground font-default">
            Advanced technology and premium design tools tailored for small businesses nationwide.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`group relative overflow-hidden border-border/10 bg-card transition-all duration-500 hover:-translate-y-2 hover:border-primary/50 hover:shadow-xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <CardHeader className="pb-4 pt-8 px-8">
                  <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-lg bg-gradient-to-br from-secondary to-chart-3 text-primary-foreground transition-transform duration-300 group-hover:scale-110">
                    <Icon className="h-7 w-7" />
                  </div>
                  <CardTitle className="font-default text-xl font-bold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8">
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}